import faker from 'faker';
import moment from 'moment';

export default Array(10)
    .fill(0)
    .map((_, index) => {
        return({
            id: index,
            contrato: faker.random.number({min: 1000, max: 5000}),
            nomeFornecedor: faker.name.findName(),
            tipoSeguroGarantia: faker.commerce.department(),
            inicioVigencia: moment(faker.date.recent(10)).format('DD/MM/YYYY'),
            fimVigencia: moment(faker.date.recent(10)).format('DD/MM/YYYY'),
            statusApolice: faker.lorem.word()
        })
    });